<template>
    <v-dialog v-model="dialogModel" max-width="1200">

        <v-toolbar dense>

            <v-app-bar-nav-icon>
                <v-icon>mdi-star-circle</v-icon>
            </v-app-bar-nav-icon>

            <v-toolbar-title>Manage PayPal rewards</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip color="primary" left>
                <template v-slot:activator="{ on }">
                    <v-btn @click="refresh()" v-on="on" icon class="mr-2">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
                <span>Reload catalog</span>
            </v-tooltip>
            <v-tooltip color="primary" left>
                <template v-slot:activator="{ on }">
                    <v-btn @click="closeClicked()" class="elevation-1" fab small color="red" v-on="on">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
                <span>Exit management</span>
            </v-tooltip>
        </v-toolbar>

        <v-card flat :loading="loading" min-height="350">
            <v-card-text>
                <v-container fluid class="pt-3">
                    <v-row>

                        <v-col cols="12" v-if="filteredRewards.length === 0 && !loading">
                            <v-alert type="info" class="body-2 mb-0">
                                You haven't selected any nominations for the selected currency. Click on the button
                                below to start!
                            </v-alert>
                        </v-col>

                        <!-- SELECT NOMINATIONS -->
                        <v-col cols="6">
                            <v-btn color="primary"
                                   :disabled="addButtonDisabled"
                                   @click="addRewardClicked">
                                Select nominations
                            </v-btn>
                        </v-col>

                        <!-- CURRENCY BUTTON GROUP -->
                        <v-col cols="6" class="text-right pt-0">
                            <v-btn-toggle v-model="currencyModel"
                                          mandatory
                                          dense
                                          rounded
                                          style="background-color: #555"
                                          class="mt-3">

                                <v-btn v-for="currency in payPalCurrencies"
                                       :key="currency.code"
                                       :value="currency.code"
                                       text>
                                    {{currency.code}}
                                </v-btn>

                            </v-btn-toggle>
                        </v-col>
                    </v-row>

                    <!-- PAY PAL REWARD CARDS -->
                    <v-row dense class="d-flex flex-wrap">

                        <pay-pal-reward-card
                                v-for="reward in filteredRewards"
                                :key="reward.id"
                                :reward="reward"
                        ></pay-pal-reward-card>

                    </v-row>

                </v-container>
            </v-card-text>

            <select-nominations-dialog v-model="payPalNewRewardDialogModel"
                                       v-if="currencyModel"
                                       :key="currencyModel"
                                       :rewards="payPalRewards"
                                       :currencies="payPalCurrencies"
                                       :currency="currencyModel"
                                       @change="nominationsSelected"

            ></select-nominations-dialog>

            <v-card-text v-if="debug">
                <json :data="filteredRewards"></json>
                <json :data="payPalRewards"></json>
            </v-card-text>

        </v-card>

    </v-dialog>
</template>

<script>

    import Json from 'vue-json-pretty';
    import MaterialHeader from '../../../../components/UI/MaterialHeader';
    import {mapActions, mapState} from 'vuex';
    import PayPalRewardCard from "./PayPalRewardCard";
    import SelectNominationsDialog from "./SelectNominationsDialog";

    const vuexModule = 'Rewards';

    export default {

        components: {
            Json,
            MaterialHeader,
            PayPalRewardCard,
            SelectNominationsDialog,

        },

        props: {
            value: {
                required: true,
                type: Boolean,
            }
        },

        data() {
            return {
                debug: false,
                currencyModel: null,
                payPalNewRewardDialogModel: false,
            }
        },

        watch: {
            value(value) {
                if (value) {
                    this.loadData();
                }
            }
        },

        computed: {

            ...mapState(vuexModule, [
                'payPalRewards',
                'payPalCurrencies',
                'payPalRewardsLoading',
                'payPalCurrenciesLoading'
            ]),

            addButtonDisabled() {
                return this.payPalRewardsLoading || this.payPalCurrenciesLoading;
            },

            filteredRewards() {

                let rewards = this.payPalRewards.sort((a, b) => {
                    if (a.cost < b.cost) return -1;
                    if (a.cost > b.cost) return 1;
                    return 0;
                });

                // Filter out ones not selected
                return rewards.filter(reward => {
                    return this.currencyModel === reward.cost_currency;
                });
            },

            dialogModel: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },

            locales() {
                return this.$store.state.PanelSettings.settings.locales;
            },

            loading() {
                return this.payPalCurrenciesLoading || this.payPalRewardsLoading;
            }
        },

        methods: {

            ...mapActions(vuexModule, [
                'getPayPalRewards',
                'getPayPalCurrencies',
                'setPayPalNominations'
            ]),

            loadData(force) {
                this.getPayPalRewards()
                    .then(response => {
                        if (force) {
                            Bus.$emit('flash-message', {
                                message: 'Rewards and currencies reloaded!'
                            });
                        }
                    })
                    .catch(error => {
                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: 'OOPS We failed to load your PayPal rewards!'
                        });
                    });

                this.getPayPalCurrencies()
                    .then(response => {

                    })
                    .catch(error => {
                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: "OOPS We failed to load PayPal supported currencies!"
                        });
                    });
            },

            nominationsSelected(nominations) {

                const data = {
                    currency: this.currencyModel,
                    nominations: nominations,
                };

                this.setPayPalNominations(data)
                    .then(() => {
                        Bus.$emit('flash-message', {
                            message: 'Nomination for ' + this.currencyModel + ' saved!'
                        });
                    })
                    .catch(() => {
                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: "OOPS We failed to save your selections!"
                        });
                    });
            },

            addRewardClicked() {
                this.payPalNewRewardDialogModel = true;
            },

            closeClicked() {
                this.$emit('input', false);
            },

            refresh() {
                this.loadData(true);
            }
        },
    }

</script>
